import hpiChart from '@/../../public/hpi chart.png';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import '../template.module.css';

import { ReportTemplatesContext } from '..';
import { RemoveBlockSVG } from './HelperSVGs';

export function HousePriceIndexGraphBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        gap: '.5rem',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={hpiChart}
        alt='HPI Chart'
        style={{
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
        }}
      />

      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock('HPI TRACT/ZIP INDEX', 'hpi');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function HousePriceIndexHeader() {
  const styles = {
    typography: {
      flex: '1',
      color: 'rgb(57, 88, 92)',
      fontSize: '1.5rem',
      fontFamily: 'Lato',
      lineHeight: '1.25rem',
      textAlign: 'center',
      fontWeight: '900',
    },
  };
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '2rem',
      }}
    >
      <Typography sx={styles.typography}>TRACT</Typography>
      <Typography sx={styles.typography}>ZIP</Typography>
      <Typography sx={styles.typography}>COUNTY</Typography>
    </Box>
  );
}
